export function discoveryPreviewVariant(idea = {}, kind = 'document') {
  const text = `${idea.title || idea.name || ''} ${idea.description || ''}`.toLowerCase();
  if (kind === 'recipe') {
    if (/cookie|biscuit|bake|brownie|dessert/.test(text)) return 1;
    if (/salad|vegetable|fresh|plant/.test(text)) return 2;
    if (/soup|stew|chili|curry/.test(text)) return 3;
    if (/pizza|flatbread|toast|sandwich/.test(text)) return 4;
    if (/pasta|noodle|spaghetti/.test(text)) return 0;
  }
  if (kind === 'game') {
    if (/word|spell|language/.test(text)) return 1;
    if (/chess|checkers|board/.test(text)) return 2;
    if (/maze|path/.test(text)) return 3;
    if (/quiz|trivia|geography/.test(text)) return 4;
  }
  let hash = 0;
  for (const char of String(idea.previewSeed == null ? idea.id || text : `${idea.id || text}:${idea.previewSeed}`)) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return hash % 5;
}
